"use client";
import { useState, useEffect } from "react";
import EventsCards from "@/components/Cards/EventsCards";

const Events = ({ data }) => {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    setEvents(data?.eventsToday || []);
  }, [data]);

  return (
    <div className="w-full p-4">
      <div className="max-w-6xl mx-auto">
        <div className="space-y-6">
          <div className="text-center">
            <h2 className="text-3xl font-bold text-foreground mb-2">
              Today's Events
            </h2>
            <div className="w-20 h-1 bg-primary mx-auto rounded-full"></div>
          </div>

          {events.length === 0 ? (
            <div className="text-center py-12 bg-card rounded-xl shadow-sm">
              <p className="text-xl text-muted-foreground">
                No events scheduled for today
              </p>
              <p className="text-muted-foreground mt-2">
                Check back later for upcoming events
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {events.map((event) => (
                <div
                  key={event.id}
                  className="transform transition-all duration-300 hover:scale-[1.02] hover:shadow-lg"
                >
                  <EventsCards
                    imgSrc={event.image}
                    Category={event.category_id}
                    title={event.name}
                    date={event.created_at}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Events;